<template>
  <div data-testid="drawer-component">
    <!-- Navigation Drawer -->
    <v-navigation-drawer
      v-model="localValue"
      v-if="!dailogBox && !dailogboxOnly"
      right
      :width="Maxwidth"
      class="position-absolute drawer-shadow overflow-hidden"
      scrollable
      hide-overlay
      stateless
      temporary
      fixed
      data-testid="navigation-drawer"
    >
      <v-card
        class="shadow-off overflow-hidden d-flex flex-column drawer-card"
        :loading="loading"
        :disabled="loading"
        loader-height="2"
        style="height: 100%;"
        data-testid="drawer-card"
      >
        <v-card-title class="align-center pa-4 popupHeader" data-testid="drawer-card-title">
          <span class="font-weight-semibold font-size-lg" data-testid="drawer-card-heading">{{ heading }}</span>
          <v-spacer></v-spacer>
          <v-menu v-if="!hideMenu" :close-on-content-click="false" offset-y transition="slide-y-transition" data-testid="drawer-card-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="ml-2" color="white" data-testid="drawer-card-menu-btn">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-2 ma-0 d-flex flex-column align-start justify-start" style="width: 200px" data-testid="drawer-card-menu-list">
              <v-list-item class="hoveritem pa-2" @click="TodailogBox('side')" data-testid="drawer-card-menu-list-side-peek">
                <v-icon class="px-2">mdi-page-layout-sidebar-left</v-icon>
                <p>Side Peek</p>
              </v-list-item>
              <v-list-item class="hoveritem pa-2" @click="TodailogBox('center')" data-testid="drawer-card-menu-list-center-peek">
                <v-icon class="px-2">mdi-page-layout-body</v-icon>
                <p>Center Peek</p>
              </v-list-item>
              <v-list-item class="hoveritem pa-2" @click="TodailogBox('full')" data-testid="drawer-card-menu-list-fullscreen-peek">
                <v-icon class="px-2">mdi-page-layout-header-footer</v-icon>
                <p>Fullscreen</p>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn icon @click="CloseDrawer()" class="ml-2" data-testid="drawer-card-close-btn">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 px-6" style="overflow-y: auto; flex-grow: 1;" data-testid="drawer-card-text">
          <slot name="body" data-testid="drawer-card-body" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="action-shadow">
          <slot name="actions" data-testid="drawer-card-actions" />
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>

    <!-- Dialog (Shows First) -->
    <v-dialog v-if="dailogBox" v-model="localValue" :width="width || 850" scrollable @click:outside="handleOutsideClick" data-testid="drawer-dialog">
      <v-card class="shadow-off" :loading="loading" :disabled="loading" loader-height="2" data-testid="drawer-dialog-card">
        <v-card-title class="popupHeader align-center py-2 px-4" data-testid="drawer-dialog-card-title">
          <span class="font-weight-semibold font-size-lg">{{ heading }}</span>
          <v-spacer></v-spacer>
          <v-menu v-if="!dailogboxOnly && !hideMenu" :close-on-content-click="false" offset-y transition="slide-y-transition" data-testid="drawer-dialog-card-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="ml-2" color="white" data-testid="drawer-dialog-card-menu-btn">
                <v-icon>mdi-dots-horizontal</v-icon>
              </v-btn>
            </template>
            <v-list class="pa-2 ma-0 d-flex flex-column align-start justify-start" style="width: 200px" data-testid="drawer-dialog-card-menu-list">
              <v-list-item class="hoveritem pa-2" @click="TodailogBox('side')" data-testid="drawer-dialog-card-menu-list-side-peek">
                <v-icon class="px-2">mdi-page-layout-sidebar-left</v-icon>
                <p>Side Peek</p>
              </v-list-item>
              <v-list-item class="hoveritem pa-2" @click="TodailogBox('center')" data-testid="drawer-dialog-card-menu-list-center-peek">
                <v-icon class="px-2">mdi-page-layout-body</v-icon>
                <p>Center Peek</p>
              </v-list-item>
              <v-list-item class="hoveritem pa-2" @click="TodailogBox('full')" data-testid="drawer-dialog-card-menu-list-fullscreen-peek">
                <v-icon class="px-2">mdi-page-layout-header-footer</v-icon>
                <p>Fullscreen</p>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn icon @click="CloseDrawer()" class="ml-2" data-testid="drawer-dialog-card-close-btn">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-8">
          <slot name="body" data-testid="drawer-dialog-card-body" />
        </v-card-text>
        <v-card-actions class="py-4 px-6">
          <slot name="actions" data-testid="drawer-dialog-card-actions" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dailogBox: !this.sidePeekDefault, // Initialize based on sidePeekDefault
      localValue: this.value, // Manage local state per instance
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    Maxwidth: {
      type: String,
      default: "40%",
    },
    dailogboxOnly: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    sidePeekDefault: {
      type: Boolean,
      default: false,
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleEscPress);
    // Initialize to side peek mode if sidePeekDefault is true
    if (this.sidePeekDefault) {
      this.dailogBox = false;
      this.localValue = this.value;
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleEscPress);
  },
  methods: {
    handleEscPress(event) {
      if (event.key === "Escape" || event.key === "Esc") {
        this.CloseDrawer();
      }
    },
     handleOutsideClick() {
    this.$emit("drawer-closed");
  },
    CloseDrawer() {
      console.log("Closing this instance only.");
      this.localValue = false;
      this.$emit("input", this.localValue);
      this.$emit("drawer-closed");
      // Reset to side peek if sidePeekDefault is true, otherwise reset to dialog
      this.dailogBox = !this.sidePeekDefault;
    },
    TodailogBox(peek) {
      if (peek === "center") {
        this.localValue = false;
        setTimeout(() => {
          this.localValue = true;
          this.dailogBox = true;
        }, 300);
      } else {
        this.dailogBox = false;
        setTimeout(() => {
          if (peek === "side") {
            this.Maxwidth = "50%";
          } else if (peek === "full") {
            this.Maxwidth = "100%";
          }
          this.localValue = true;
        }, 300);
      }
    },
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
    localValue(newVal) {
      this.$emit("input", newVal);
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer {
  position: fixed !important;
  z-index: 100;
}
.v-dialog {
  height: 50vh;
}
.drawer-shadow {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}
.action-shadow {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
}
.hoveritem:hover {
  background-color: #193541;
  color: white !important;
  border-radius: 8px;
}
.hoveritem:hover .v-icon {
  color: white !important;
}
.hoveritem {
  width: 100%;
}
.drawer-card {
  border-radius: 0px !important;
}
</style>
